import styled from 'styled-components';

const PricingList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Pricing = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PricingAnswers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export { Pricing, PricingAnswers, PricingList };
